module.exports = __webpack_public_path__ + "img/hamle.65565104.jpg";